// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: 'sigtim/powerbi',
  component: () => import('modules/powerbi/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          }
        ]
      },
      name: 'IconListDash',
      component: () => import('modules/powerbi/IconList.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'sigtim',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboard',
            name: 'DashSigTim'
          }
        ]
      },
      name: 'DashSigTim',
      component: () => import('modules/powerbi/SigTim.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'estoque-recarga',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Recarga Estoque',
            name: 'RecargaEstoque'
          }
        ]
      },
      name: 'RecargaEstoque',
      component: () => import('modules/powerbi/RecargaEstoque'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.recargaestoque')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'rastreabilidade-recarga',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Rastreabilidade de Recarga',
            name: 'RastreabilidaRecarga'
          }
        ]
      },
      name: 'RastreabilidaRecarga',
      component: () => import('modules/powerbi/RastreabilidaRecarga'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.rastreabilidarecarga')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'rastreabilidade-chip',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Rastreabilidade de Chip',
            name: 'RastreabilidadeChip'
          }
        ]
      },
      name: 'RastreabilidadeChip',
      component: () => import('modules/powerbi/RastreabilidadeChip'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.rastreabilidadechip')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'qualidade',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Qualidade',
            name: 'Qualidade'
          }
        ]
      },
      name: 'Qualidade',
      component: () => import('modules/powerbi/Qualidade'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.qualidade')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'capilaridade',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Capilaridade',
            name: 'Capilaridade'
          }
        ]
      },
      name: 'Capilaridade',
      component: () => import('modules/powerbi/Capilaridade'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.capilaridade')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'invasoes-penalidades',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Invasões de Penalidades',
            name: 'InvasoesPenalidades'
          }
        ]
      },
      name: 'InvasoesPenalidades',
      component: () => import('modules/powerbi/InvasoesPenalidades'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.invasoespenalidades')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'penetracao-chip',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Penetração de Chip',
            name: 'PenetracaoChip'
          }
        ]
      },
      name: 'PenetracaoChip',
      component: () => import('modules/powerbi/PenetracaoChip'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.penetracaochip')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'paliativo',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Painel Executivo - Chip',
            name: 'Paliativo'
          }
        ]
      },
      name: 'Paliativo',
      component: () => import('modules/powerbi/Paliativo'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.paliativo')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'drilldownchip',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Drill Down Chip',
            name: 'DrillDownChip'
          }
        ]
      },
      name: 'DrillDownChip',
      component: () => import('modules/powerbi/DrillDownChip'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.drill.down.chip')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'rastreabilidade-apis',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Rastreabilidade de APIs',
            name: 'RastreabilidadeApis'
          }
        ]
      },
      name: 'RastreabilidadeApis',
      component: () => import('modules/powerbi/RastreabilidadeApis'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.api.traceability')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'homebroker',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Home Broker',
            name: 'HomeBroker'
          }
        ]
      },
      name: 'HomeBroker',
      component: () => import('modules/powerbi/HomeBroker'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.home.broker')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'importmanagement',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'Gestão de importação',
            name: 'ImportManagement'
          }
        ]
      },
      name: 'ImportManagement',
      component: () => import('modules/powerbi/ImportManagement'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.import.management')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'timclosing',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Dashboards',
            name: 'IconListDash'
          },
          {
            text: 'TIM Fechamento',
            name: 'TimClosing'
          }
        ]
      },
      name: 'TimClosing',
      component: () => import('modules/powerbi/TimClosing'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.sigtim.tim.closing')) {
          next();
        } else {
          next('/');
        }
      }
    },
  ]
};
